export default function () {
    return {
        restrict: 'E',
        scope: {
            onLanguageToggle: '=onLanguageToggle',
            isEnglishListActive: '=',
            colorClass: '@',
            localizedText: '=',
        },
        template: `<div class="mdc-tab-scroller col">
                <div class="mdc-tab-scroller__scroll-area">
                    <div class="mdc-tab-scroller__scroll-content">
                        <button class="{{isEnglishListActive ? 'mdc-tab mdc-tab--active' : 'mdc-tab'}}" role="tab"
                            aria-selected="true" tabindex="0" ng-click="onLanguageToggle()">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label {{colorClass}}">{{localizedText('ENGLISH')}}</span>
                            </span>
                            <span class="mdc-tab__ripple {{colorClass}}"></span>
                        </button>

                        <div class="vl"></div>

                        <button class="{{!isEnglishListActive ? 'mdc-tab mdc-tab--active' : 'mdc-tab'}}" role="tab"
                            aria-selected="true" tabindex="0" ng-click="onLanguageToggle()">
                            <span class="mdc-tab__content">
                                <span class="mdc-tab__text-label {{colorClass}}">{{localizedText('SPANISH')}}</span>
                            </span>
                            <span class="mdc-tab__ripple {{colorClass}}"></span>
                        </button>
                    </div>
                </div>
            </div>`
    };
};